import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/de-ch';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

declare module "dayjs" {
    interface Dayjs {
        formatIf(format: string, invalidValue?: string): string;
        toISOStringIf(invalidValue?: string): string;
        humanReadableDate(): string;
        humanReadableDateTime(): string;
    }
}

// Configure dayjs locale:
dayjs.locale('de-ch');
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Europe/Zurich');

const origFormat = dayjs.prototype.format;
const origToISOString = dayjs.prototype.toISOString;

/**
 * adds a default response string if the date is invalid, instead of an error
 */
dayjs.prototype.formatIf = function (format: string, invalidValue = '') {
    if (this.isValid()) {
        return origFormat.call(this, format);
    } else {
        return invalidValue;
    }
};

/**
 * adds a default response string if the date is invalid, instead of an error
 */
dayjs.prototype.toISOStringIf = function (invalidValue = '') {
    if (this.isValid()) {
        return origToISOString.call(this);
    } else {
        return invalidValue;
    }
};

dayjs.prototype.humanReadableDate = function () {
    if (this.isValid()) {
        return this.format('DD.MM.YYYY');
    } else {
        return '-';
    }
};

dayjs.prototype.humanReadableDateTime = function () {
    if (this.isValid()) {
        return this.format('DD.MM.YYYY HH:mm');
    } else {
        return '-';
    }
};

/**
 * Fixing serialization of dayjs objects: Instead of using UTC when
 * serializing the date, we use format(), which uses the local timezone.
 * @param option
 * @param dayjsClass
 * @param dayjsFactory
 */
const JsonPlugin = (option: any, dayjsClass: typeof Dayjs, dayjsFactory: typeof dayjs) => {
    dayjsClass.prototype.toJSON = function () {
        if (this.isValid()) {
            return this.format();
        } else {
            return '';
        }
    };
};
dayjs.extend(JsonPlugin);
